import {
  ICashMovementAllowedStores,
  ICashMovementExportParams,
  CashMovementExportResult,
} from "src/@types/cash-movement";

import { apiSlice } from "./http";
import { toQueryParams } from "@/utils/to-query-params";

const HTTP_NO_CONTENT = 204;

async function exportRequestHandler(
  response: Response,
): Promise<CashMovementExportResult> {
  if (response.status === HTTP_NO_CONTENT) {
    return {};
  }
  return response.json().catch(() => response.text());
}

export const cashMovementApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCashMovementAllowedStores: builder.query<
      ICashMovementAllowedStores,
      void
    >({
      query: () => ({
        url: "/cash-movement/allowed-stores",
        method: "GET",
      }),
    }),
    exportCashMovementExcel: builder.mutation<
      CashMovementExportResult,
      ICashMovementExportParams
    >({
      query: (filters) => ({
        url: `/cash-movement/export?${toQueryParams(filters)}`,
        method: "POST",
        responseHandler: exportRequestHandler,
      }),
    }),
    exportCashMovementPdf: builder.mutation<
      CashMovementExportResult,
      ICashMovementExportParams
    >({
      query: (filters) => ({
        url: `/cash-movement/export.pdf?${toQueryParams(filters)}`,
        method: "POST",
        responseHandler: exportRequestHandler,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCashMovementAllowedStoresQuery,
  useExportCashMovementExcelMutation,
  useExportCashMovementPdfMutation,
} = cashMovementApi;
